<template>
  <b-modal
    id="resetPassword"
    modal-class="modal-cover"
    v-model="isVisible"
    hide-backdrop
    hide-footer
    content-class="shadow-lg"
    centered
    no-header-close
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <div class="trip-login-wrap">
            <h3>{{ t('resetPasswordTitle') }}</h3>

            <div class="trip-border-content">
              <p>{{ t('resetPasswordEmailPlaceholder') }}</p>
            </div>

            <form @submit.prevent="handleResetPassword">
              <div class="trip-login-field">
                <b-form-input
                  dir="ltr"
                  v-model="email"
                  autocapitalize="none"
                  id="email"
                  :placeholder="t('loginEmailLabel')"
                  class="log_in_medium text-right"
                  required>
                </b-form-input>
              </div>

              <button
                id="trip-login-btn"
                type="submit"
                :disabled="isLoading">
                <b-spinner small v-if="isLoading"></b-spinner>
                <span v-else>{{ t('resetPasswordSendLink') }}</span>
              </button>
            </form>

            <div class="trip-login-bottom-btn">
              <button
                class="trip-login-btn"
                type="button"
                :disabled="isLoading"
                @click="backToLogin">
                {{ t('resetPasswordBackToLogin') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex';
import { translationMixin } from '@/mixins/translationMixin';

export default {
  mixins: [translationMixin],
  props: ["value"],
  data() {
    return {
      email: '',
      isLoading: false
    };
  },
  computed: {
    isVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    ...mapActions(['requestPasswordReset']),
    
    async handleResetPassword() {
      if (!this.validateEmail(this.email)) {
        return;
      }
      
      this.isLoading = true;
      try {
        const success = await this.requestPasswordReset(this.email.trim());
        if (success) {
          this.$store.dispatch('showModalWithParameters', {
            errorNumber: 'password_reset_email_sent',
            type: 'textConverter'
          });
          this.isVisible = false;
          this.email = '';
        }
        // If not success, the error message was already shown by the action
      } finally {
        this.isLoading = false;
      }
    },
    
    validateEmail(email) {
      const trimmedEmail = email.trim();
      
      if (trimmedEmail.includes(' ')) {
        this.$store.dispatch('showModalWithParameters', {
          errorNumber: 'invalid_email_spaces',
          type: 'textConverter'
        });
        return false;
      }
      
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(trimmedEmail)) {
        this.$store.dispatch('showModalWithParameters', {
          errorNumber: 'invalid_email_format',
          type: 'textConverter'
        });
        return false;
      }
      
      return true;
    },
    
    backToLogin() {
      if (!this.isLoading) {
        this.isVisible = false;
        this.email = '';
        this.$store.dispatch('showModal', 'mainLogIn');
      }
    }
  }
};
</script>

<style scoped>
.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 45px 55px;
  border: none;
}

.modal-dialog {
  max-width: 310px;
  margin: 1.75rem auto !important;
  margin-top: 10% !important;
}

.modal-content {
  background: #FFFFFF;
  box-shadow: 4px 4px 4px rgb(0 0 0 / 10%);
  border-radius: 25px;
  border: none;
}

.trip-login-wrap {
  text-align: center;
}

.trip-login-wrap h3 {
  font-weight: 800;
  font-size: 18px;
  line-height: 21px;
  color: #2E2E3A;
  margin-bottom: 15px;
  text-align: center;
}

.trip-border-content {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 12px;
  position: relative;
}

.trip-border-content p {
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: #2E2E3A;
  text-align: center;
  position: relative;
  z-index: 1;
  display: inline-block;
  background-color: #fff;
  padding: 0 10px;
}

.trip-border-content::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  height: 1px;
  background-color: #2E2E3A;
  z-index: 0;
}

.trip-login-field {
  margin-bottom: 10px;
}

.trip-login-field input {
  height: 30px;
  width: 100%;
  text-align: right;
  border: 1px solid #C1C0C0;
  border-radius: 22px;
  font-size: 12px;
  line-height: 14px;
  padding: 5px 15px !important;
  color: black;
}

button#trip-login-btn {
  width: 100%;
  height: 30px;
  background: #34D0B6;
  border-radius: 22px;
  border: none;
  font-weight: 500;
  font-size: 12px;
  color: white;
  margin-top: 15px;
}

button#trip-login-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.trip-login-bottom-btn {
  margin-top: 25px;
}

button.trip-login-btn {
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: #FFFFFF;
  width: 129px;
  height: 30px;
  background: #07A0C3;
  border-radius: 22px;
  border: none;
}

button.trip-login-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.trip-login-wrap > * {
  margin-bottom: 10px;
}

.trip-login-wrap > *:last-child {
  margin-bottom: 0;
}

/* Override bootstrap modal styles */
:deep(.modal-header) {
  display: none;
}

:deep(.modal) {
  border: none;
}

:deep(.modal-content) {
  border: none;
}
</style> 